import Reflux from "reflux";

import UIActions from "../actions/UIActions";

var HoverStore = Reflux.createStore({
  storeName: 'HoverStore',
  listenables: UIActions,
  init() {
    this.hover = null;
  },

  onItemOver(hoverId) {
    this.hover = hoverId;
    this.trigger(this.hover);
  },

  onItemOut() {
    this.hover = null;
    this.trigger(this.hover);
  },

  getInitialState() {
    return this.hover;
  },
});

export default HoverStore;
